var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cyberinsurancepay",attrs:{"id":"cyberinsurance-pay"}},[_c('CyberInsurancePackage',{class:{ packageDiv: _vm.callBackApi.formPackage }})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }